/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import brokenRocket from "assets/images/brokenRocket.svg";
// SB-260 remove background asset for Starbreeze
import { Button } from "components/base/_common/index";
import styles from "./ErrorPage.module.scss";

export default class extends React.Component {
  render() {
    return (
      <div className={styles.errorPage}>
        <div>
          <div className={styles.errorPageContent}>
            <img src={brokenRocket} alt="space ship alien" />
            <div className={styles.errorPageText}>
              <h2 className={styles.textHeading}>
                <Trans i18nKey="ErrorPage500.title">Error 500 - Internal Server Error</Trans>
              </h2>
              <div className={styles.textContent}>
                <Trans i18nKey="ErrorPage500.textContent">
                  <p>Don’t worry, our team on Mars are working hard to fix this!</p>
                  <p>It won’t be long... It won’t be long...</p>
                </Trans>

                <div>
                  <Link to="/">
                    <Button>
                      <Trans i18nKey="ErrorPage500.buttonAction">Back To Home</Trans>
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
